import { render, staticRenderFns } from "./ItemWriteDefaultLayout.vue?vue&type=template&id=09889988&scoped=true&"
import script from "./ItemWriteDefaultLayout.vue?vue&type=script&lang=js&"
export * from "./ItemWriteDefaultLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09889988",
  null
  
)

export default component.exports